import { Box, Grid, Typography } from '@material-ui/core';
import { CustomHiddenInput, CustomTextField } from '@uml/uml-components';
import { FormProvider, useForm } from 'react-hook-form';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/core/styles';
import { postComment } from '../services/comments';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  addCommentTitle: {
    marginBottom: 16,
  },
  addFormContent: {
    display: 'flex',
    aliginItems: 'center',
  },
  commentItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: 16,

    '&:last-of-type': {
      borderBottom: 0,
      marginBottom: 8,
    },
  },
  commentAuthor: {
    display: 'flex',
  },
  commentAuthorAvatar: {
    display: 'flex',
    minWidth: 40,
    minHeight: 40,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    fontSize: 16,
    marginRight: 16,
    marginBottom: 8,
  },
  commentCreatedDate: {
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
  commentContent: {
    paddingLeft: 56,
  },
}));

const Comments = ({ projectId, userId, userName, userLastName, comments }) => {
  const classes = useStyles();
  const [count, setCount] = React.useState(0);
  const methods = useForm();
  const { enqueueSnackbar } = useSnackbar();
  const [commentsItems, setCommentsItems] = React.useState([]);
  const [visibleForm, setVisibleForm] = React.useState(true);

  React.useEffect(() => {
    setCount(comments.length);
    setCommentsItems(comments);
  }, [comments]);

  React.useEffect(() => {
    methods.setValue('external_uuid', userId);
    methods.setValue('first_name', userName);
    methods.setValue('last_name', userLastName);
    methods.setValue('project', projectId);

    if (!userId || userId === '') {
      setVisibleForm(false);
    }
  }, [userId, userName, userLastName, projectId]);

  const handleAddComment = async (data) => {
    const formData = {
      projectId,
      ...data,
    };

    try {
      const { status, data } = await postComment(service, formData);
      if (status === 201) {
        setCommentsItems([...commentsItems, data]);
        setCount(count + 1);
        setVisibleForm(false);
        enqueueSnackbar('Dodano komentarz', {
          variant: 'success',
        });
      }
    } catch (e) {
      enqueueSnackbar('Nie udało się dodać komentarza', {
        variant: 'error',
      });
    }
  };

  const CommentsItem = () => {
    return commentsItems?.map((comment) => {
      return (
        <Grid className={classes.commentItem} key={comment.project}>
          <Grid className={classes.commentAuthor}>
            <span className={classes.commentAuthorAvatar}>
              {comment.first_name.substring(0, 1)}
              {comment.last_name.substring(0, 1)}
            </span>
            <Grid>
              <Typography>
                {comment.first_name} {comment.last_name}
              </Typography>
              <Typography className={classes.commentCreatedDate}>
                {comment.created}
              </Typography>
            </Grid>
          </Grid>
          <Typography className={classes.commentContent}>
            {comment.content}
          </Typography>
        </Grid>
      );
    });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id='panel1a-header'>
            <Typography>Komentarze: {count}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid item xs={12}>
                <CommentsItem />
              </Grid>
              {visibleForm && (
                <Grid item xs={12}>
                  {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                  <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(handleAddComment)}>
                      <Typography className={classes.addCommentTitle}>
                        Dodaj komentarz
                      </Typography>
                      <Box className={classes.addFormContent}>
                        <CustomHiddenInput id='firstName' name='first_name' />
                        <CustomHiddenInput id='lastName' name='last_name' />
                        <CustomHiddenInput
                          required
                          id='externalUuid'
                          name='external_uuid'
                        />
                        <CustomHiddenInput
                          required
                          id='project'
                          name='project'
                        />
                        <CustomTextField
                          required
                          size='small'
                          margin='none'
                          label='Wprowadź komentarz'
                          id='commnent'
                          name='content'
                          maxLengthValue={2000}
                          maxLengthMessage='Maksymalna dłogość komentarza to 2000 znaków.'
                        />
                        <IconButton
                          variant='contained'
                          type='submit'
                          aria-label='Dodaj komentarz'
                        >
                          <SendIcon />
                        </IconButton>
                      </Box>
                    </form>
                  </FormProvider>
                </Grid>
              )}
              {!userId ||
                (userId === '' && (
                  <Grid item xs={12}>
                    <Typography className={classes.addCommentTitle}>
                      Aby móc dodać komentarz, należy się zalogować.
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

Comments.propTypes = {
  projectId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userLastName: PropTypes.string.isRequired,
  comments: PropTypes.arrayOf(PropTypes.object),
};

Comments.defaultProps = {
  comments: [],
};

export default Comments;
